import React, { useState } from "react";
import AuthLayout from "./AuthLayout";
import { Row, Col, Input, Button, Form } from "antd";
import { Link, useHistory } from "react-router-dom";
import SuccessMessage from "./SuccessMessage";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import { connect } from "react-redux";
import { ResetEmailPassword } from "../../redux/actions/authentication";
import { toast } from "react-toastify";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { forgetPasswordCredentialsSchema } from "../validattion";

const ForgotPassword = (props) => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  let { ResetEmailPassword } = props;
  const gotoHome = () => {
    history.push("/");
  };

  const styles = {
    marginTop: "4rem",
  };

  // Form
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(forgetPasswordCredentialsSchema),
  });

  const resetPasswordLink = async (data) => {
    setLoading(true);
    let res = await ResetEmailPassword(data);
    if (res.success) {
      setShowSuccess(true);
      toast("Email Reset Link Sent Successfully", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      setLoading(false);
      toast.error(res.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    setLoading(false);
  };
  return (
    <>
      <AuthLayout
        style={styles}
        fadeName="fade-left"
        pageTitle="Forgot Password"
      >
        {!showSuccess ? (
          <>
            <div className="auth-title">
              <h2>Recover Password</h2>
              <p>Enter your registered email address to reset your password</p>
            </div>
            <Form onFinish={handleSubmit(resetPasswordLink)} autoComplete="off">
              <Row gutter={24} style={{ marginTop: "4rem" }}>
                <Col xs={24} xl={24} lg={24}>
                  <div className="form-group">
                    <Controller
                      name="email"
                      control={control}
                      defaultValue=""
                      render={({ field }) => <Input {...field} />}
                    />
                    {errors.email && (
                      <span className="error">
                        Please, enter a valid email address
                      </span>
                    )}
                  </div>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col xs={24} xl={24} lg={24}>
                  <Button
                    block
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                  >
                    {loading ? "Processing Request..." : "SEND LINK"}
                  </Button>
                </Col>
              </Row>
            </Form>

            <Row>
              <Col xs={24} xl={24} lg={24}>
                <p className="register">
                  <Link to="/auth/login">
                    <ArrowRightAltIcon /> Return to Login
                  </Link>
                </p>
              </Col>
            </Row>
          </>
        ) : (
          <SuccessMessage
            description="Code has been sent to your mail, Check your inbox to proceed"
            successTitle="SUCCESSFULLY SENT"
            action={gotoHome}
          />
        )}
      </AuthLayout>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    auth_error: state.authReducer.auth_error,
    reset_email: state.authReducer.reset_email,
  };
};

export default connect(mapStateToProps, { ResetEmailPassword })(ForgotPassword);
